import { RefObject, useEffect, useState } from 'react';

/**
 * Get the size of the scrollbar.
 * @returns The size of the scrollbar.
 */
export const getScrollbarSize = () => {
  const scrollDiv = document.createElement('div');
  scrollDiv.style.width = '100px';
  scrollDiv.style.height = '100px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);

  const scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);

  return scrollbarSize;
};

/**
 * Adds the scrollbar-size css variable to the :root context=
 */
export const useScrollbarSizeClassname = () => {
  useEffect(() => {
    document.body.style.setProperty(
      '--scrollbar-size',
      `${getScrollbarSize()}px`
    );
  }, []);
};

/**
 * Returns true if the element has a scrollbar.
 * @param ref - The ref of the element to check.
 * @returns True if the element has a scrollbar.
 */
export const useHasScrollbar = (ref: RefObject<HTMLElement>) => {
  const [hasScrollbar, setHasScrollbar] = useState(false);

  useEffect(() => {
    const container = ref.current;
    if (container) {
      const resizeObserver = new ResizeObserver(() => {
        setHasScrollbar(container.scrollHeight > container.clientHeight);
      });
      resizeObserver.observe(container);
      return () => resizeObserver.disconnect();
    }
  }, [ref]);

  return hasScrollbar;
};
